import React from 'react';

const ServerIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M2.5 5.41667C2.5 4.86438 2.94772 4.41667 3.5 4.41667H16.5C17.0523 4.41667 17.5 4.86438 17.5 5.41667V6.25C17.5 6.80228 17.0523 7.25 16.5 7.25H3.5C2.94772 7.25 2.5 6.80228 2.5 6.25V5.41667Z" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M2.5 9.58333C2.5 9.03105 2.94772 8.58333 3.5 8.58333H16.5C17.0523 8.58333 17.5 9.03105 17.5 9.58333V10.4167C17.5 10.969 17.0523 11.4167 16.5 11.4167H3.5C2.94772 11.4167 2.5 10.969 2.5 10.4167V9.58333Z" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M2.5 13.75C2.5 13.1977 2.94772 12.75 3.5 12.75H16.5C17.0523 12.75 17.5 13.1977 17.5 13.75V14.5833C17.5 15.1356 17.0523 15.5833 16.5 15.5833H3.5C2.94772 15.5833 2.5 15.1356 2.5 14.5833V13.75Z" stroke="currentColor" strokeWidth="1.5"/>
    <path d="M5.83333 5.83333H5.84167" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M5.83333 10H5.84167" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
    <path d="M5.83333 14.1667H5.84167" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
  </svg>
);

export default ServerIcon;

